import { XMarkIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'

/**
 * Pills used for dietary tags, filters, etc.
 *
 * Props
 * • children  – tag label
 * • onRemove  – optional; renders an ✕ button when supplied
 * • className – override / extend styling
 */
export default function Tag({ children, onRemove, className = '' }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full bg-soft-yellow/40 px-2 py-0.5',
        'text-xs font-medium text-charcoal',
        className
      )}
    >
      {children}
      {onRemove && (
        <button
          onClick={onRemove}
          className="hover:text-red-600 transition-colors"
          aria-label="remove tag"
        >
          <XMarkIcon className="h-3 w-3" />
        </button>
      )}
    </span>
  )
}
